import type { CityConfig } from "../city-template/types";

export const auroraConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Illinois Dept of Public Health Vital Records", href: "https://dph.illinois.gov/topics-services/birth-death-other-records.html", description: "Official Illinois vital records office in Springfield" },
    { label: "Marriage Licenses — Kane County Clerk", href: "https://www.kanecountyil.gov/", description: "Kane County Clerk — marriage license issuance" },
    { label: "Divorce Records — Kane County Circuit Clerk", href: "https://www.kanecountyil.gov/", description: "Kane County Circuit Clerk — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of IDPH for online vital record orders" },
  ],
  city: "Aurora",
  state: "Illinois",
  stateAbbr: "IL",
  slug: "aurora",
  route: "/aurora",
  title: "Emergency Passport Aurora, IL — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Aurora, Illinois — as fast as 24 hours. Fast passport renewal and new passport applications for Aurora, Montgomery, North Aurora, Sugar Grove, and all Kane and DuPage County residents. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Aurora, IL",
  heroSubtitle: "Aurora travelers — from the Fox Valley manufacturing corridor to Aurora University students to Kane and DuPage County families — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service serving all of Aurora and the Fox Valley.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Historic%20downtown%20Aurora%20Illinois%20along%20the%20Fox%20River%20with%20the%20Leland%20Tower%2C%20the%20Paramount%20Theatre%20building%2C%20modern%20bridges%20crossing%20the%20river%2C%20mix%20of%20historic%20red-brick%20and%20modern%20architecture%2C%20lush%20green%20riverbanks%2C%20warm%20afternoon%20sunlight%2C%20diverse%20suburban%20cityscape%2C%20professional%20city%20photography%20without%20text%20or%20people%2C%20Fox%20Valley%20atmosphere&width=1800&height=700&seq=aurora-hero-001&orientation=landscape",
  heroImageAlt: "Aurora Illinois downtown skyline along the Fox River with Paramount Theatre and Leland Tower",
  geoPosition: "41.7606;-88.3201",
  geoPlacename: "Aurora, Illinois",
  lastModified: "2026-06-02",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Approximately 45 minutes east of Aurora via I-88",
  },
  nearbyCitiesZips: [
    { name: "Aurora", zips: "60502, 60503, 60504, 60505, 60506, 60507" },
    { name: "Naperville", zips: "60540, 60563, 60564, 60565" },
    { name: "Montgomery", zips: "60538" },
    { name: "North Aurora", zips: "60542" },
    { name: "Sugar Grove", zips: "60554" },
    { name: "Oswego", zips: "60543" },
    { name: "Batavia", zips: "60510, 60539" },
    { name: "Geneva", zips: "60134" },
    { name: "St. Charles", zips: "60174, 60175" },
    { name: "Plainfield", zips: "60544, 60585, 60586" },
    { name: "Bolingbrook", zips: "60440, 60490" },
    { name: "Yorkville", zips: "60560" },
    { name: "Warrenville", zips: "60555" },
    { name: "West Chicago", zips: "60185, 60186" },
    { name: "Elburn", zips: "60119" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to Chicago Passport Agency — no 45-minute drive required" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-building-line", title: "Fox Valley Hub", desc: "Serving Aurora manufacturing, Aurora University, and Kane County families" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — no trip to downtown Chicago required" },
  ],
  internalLinks: [
    { name: "Expedited passport in Naperville, IL", route: "/naperville" },
    { name: "Emergency passport help in Geneva, IL", route: "/illinois" },
    { name: "Urgent passport services in Rockford, IL", route: "/rockford" },
    { name: "Illinois passport services overview", route: "/illinois" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Aurora, Illinois remotely via secure registered courier. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (45 minutes east via I-88) — without you making the trip. Aurora residents can ship from any UPS or FedEx in Kane or DuPage County.",
  fpcOfficeDistance: "Serving Aurora, Montgomery, North Aurora, Sugar Grove, Oswego, Batavia, Geneva, St. Charles, Plainfield, Bolingbrook, Yorkville, Warrenville, West Chicago, Elburn, and all of the Fox Valley",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Aurora and the Fox Valley. From downtown Aurora along the Fox River to the industrial corridor on the east side, from Aurora University to the residential neighborhoods of the south and west sides — we serve all of Kane and DuPage counties.",
  nearbyCitiesIntro: "We serve Aurora and all nearby communities including Montgomery, North Aurora, Sugar Grove, Oswego, Batavia, Geneva, St. Charles, Plainfield, Bolingbrook, Yorkville, Warrenville, West Chicago, and Elburn. We also serve DuPage County, Kendall County, and all Fox Valley communities.",
  howItWorksIntro: "Most Aurora travelers complete everything online and ship documents overnight. No need to drive 45 minutes to downtown Chicago — our couriers handle the Chicago Passport Agency trip for you.",
  mistakesIntro: "Aurora is the second-largest city in Illinois with a diverse population, strong manufacturing base, and growing university community. Here are the most common passport mistakes we see from Fox Valley travelers.",
  testimonialsIntro: "Aurora travelers — from the Fox Valley manufacturing corridor to Aurora University students to Kane County families — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Aurora, IL? Here are the most common ones we hear from Fox Valley travelers.",
  statePageRoute: "/states/illinois",
  statePageName: "Illinois",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — hand-delivered", "No drive to downtown Chicago required", "Perfect for manufacturing and university travel deadlines", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — hand-delivered", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive 45 minutes to downtown Chicago", "Full day commitment — parking and downtown navigation"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Aurora travelers with immediate departure needs — as fast as 24 hours. Our couriers use the Chicago Passport Agency — 45 minutes away but you never make the trip.",
      bullets: ["24–48 hour turnaround available", "Chicago Passport Agency direct courier", "Fox Valley manufacturing and university travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Aurora adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Aurora address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Aurora residents and families — including Aurora University students, new citizens, and Fox Valley families.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Aurora residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Aurora and Fox Valley families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Aurora and Fox Valley residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Aurora IL", description: "Urgent passport processing for Aurora Illinois travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Aurora IL", description: "Fast passport renewal for Aurora Illinois residents with a previously-issued passport." },
    { name: "First-Time Passport Aurora IL", description: "New passport application services for Aurora Illinois residents applying for their first passport." },
    { name: "Child Passport Aurora IL", description: "Minor passport services for Aurora Illinois families with children under 16." },
  ],
  testimonials: [
    {
      name: "Maria G.",
      location: "Aurora, IL",
      rating: 5,
      text: "Study abroad program in Spain in 5 days and my passport was expired. Fast Passport Center had my renewed passport in 2 days. I shipped from the UPS Store on Orchard Road and the whole process was seamless. They saved my semester.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "James L.",
      location: "Montgomery, IL",
      rating: 5,
      text: "Family trip to Mexico with 6 days notice. Three passports for our family. Done in 3 days. We shipped from FedEx on Galena Boulevard and everything was perfect. Incredible service for the Fox Valley.",
      service: "Family Passport Bundle",
    },
    {
      name: "Patricia R.",
      location: "Aurora, IL",
      rating: 5,
      text: "Business trip to Germany with 8 days notice. Fast Passport Center walked me through every step and had my passport in 3 days. The courier service is a game-changer for Aurora professionals who can't take a day off.",
      service: "Emergency Passport",
    },
    {
      name: "Carlos M.",
      location: "Batavia, IL",
      rating: 5,
      text: "Lost my passport the week before visiting family in Colombia. Fast Passport Center replaced it in 48 hours. From Batavia, driving to Chicago would have been a nightmare. They saved our family reunion.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "aur-1",
      name: "Aurora Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "525 N Broadway",
      city: "Aurora",
      state: "IL",
      zip: "60505",
      phone: "(630) 897-5766",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Aurora, near the Fox River",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Aurora acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient to downtown Aurora and the Fox Valley.",
      icon: "ri-mail-line",
    },
    {
      id: "aur-2",
      name: "Naperville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1750 W Ogden Ave",
      city: "Naperville",
      state: "IL",
      zip: "60540",
      phone: "(630) 420-0533",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Naperville, approximately 10 miles east of Aurora",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for eastern Aurora and Naperville residents. Alternative option for east-side travelers.",
      icon: "ri-mail-line",
    },
    {
      id: "aur-3",
      name: "Geneva Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "N 1st St",
      city: "Geneva",
      state: "IL",
      zip: "60134",
      phone: "(630) 232-7741",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Geneva, approximately 12 miles north of Aurora",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Geneva, St. Charles, and northern Kane County. Good alternative for north-side travelers.",
      icon: "ri-mail-line",
    },
    {
      id: "aur-4",
      name: "Bolingbrook Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2701 75th St",
      city: "Bolingbrook",
      state: "IL",
      zip: "60440",
      phone: "(630) 759-0540",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Bolingbrook, approximately 15 miles southeast of Aurora",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Bolingbrook, Plainfield, and southeastern Aurora residents.",
      icon: "ri-mail-line",
    },
    {
      id: "aur-5",
      name: "Kane County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "719 S Batavia Ave",
      city: "Geneva",
      state: "IL",
      zip: "60134",
      phone: "(630) 232-5950",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Geneva, Kane County Government Building",
      website: "https://www.kanecountyil.gov/",
      websiteLabel: "Kane County",
      notes: "Kane County Clerk passport acceptance. Extended hours compared to some post office locations. Call to confirm current passport acceptance hours.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 45 min drive to downtown Chicago", fpc: "No — ship from Aurora" },
    { feature: "Parking & Navigation", agency: "Downtown Chicago parking costs", fpc: "Ship from your neighborhood" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Aurora manufacturing professionals and university students often discover passport issues just before departure. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo services near Fox Valley Mall or Orchard Road sometimes produce photos that meet ID requirements but fail passport standards. Photos must be exactly 2x2 inches on a white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 rejection reasons at Kane and DuPage County acceptance facilities.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking Acceptance Facilities Early Enough",
      description: "Aurora and Geneva Post Office appointments fill during summer travel season and university break periods. Book 2–3 weeks ahead.",
    },
    {
      icon: "ri-road-map-line",
      title: "Underestimating the Trip to Chicago",
      description: "Many Aurora residents attempt to drive to the Chicago Passport Agency in an emergency. The 45-minute drive plus downtown parking and navigation means a half-day lost — our courier service is faster and more reliable.",
    },
    {
      icon: "ri-time-line",
      title: "Assuming 4–6 Weeks Is Enough",
      description: "Routine processing takes 6–13 weeks. If your travel is within 10 weeks, use expedited service. Spring break and summer travel from the Fox Valley peaks March–August — plan ahead.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in the Aurora area or Fox Valley." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx near Fox Valley Mall or downtown Aurora." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to the Chicago Passport Agency — just 45 minutes away but you never make the trip." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Aurora address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Aurora, IL?", a: "Fast Passport Center offers emergency passport processing in Aurora, Illinois in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (45 minutes east via I-88) — without you making the trip." },
    { q: "Does Aurora have its own passport agency?", a: "No — Aurora does not have a regional passport agency. The nearest facility is the Chicago Passport Agency (approximately 45 minutes east via I-88). Fast Passport Center's courier service means Aurora residents never need to make the trip." },
    { q: "Can I get an expedited passport in Geneva, Batavia, or St. Charles?", a: "Absolutely. Fast Passport Center serves all of the Fox Valley including Geneva, Batavia, St. Charles, Montgomery, North Aurora, Sugar Grove, Oswego, Yorkville, and all of Kane County. Our service works the same way everywhere." },
    { q: "What airport do Aurora travelers use for international flights?", a: "Chicago O'Hare International Airport (ORD) is the primary airport for Aurora and Fox Valley travelers. O'Hare is approximately 45 minutes east via I-88 and offers direct international flights worldwide. Chicago Midway (MDW) is also an option for domestic connections. Always verify passport validity for at least 6 months past your return date." },
    { q: "How much does an expedited passport cost in Aurora, IL?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in Aurora?", a: "Walgreens, CVS, and UPS Store locations throughout Aurora, Montgomery, and North Aurora offer passport photos. FedEx Office locations also provide them. Photos must be 2x2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve Aurora University students?", a: "Yes. Fast Passport Center serves all of the Fox Valley including Aurora University students, faculty, and staff. We understand study abroad schedules and academic conference deadlines. Our courier service is especially valuable for students who can't take a day off to go to Chicago." },
    { q: "Can I get a passport for my child in Aurora?", a: "Yes. Fast Passport Center provides child passport services for minors under 16 throughout Aurora and the Fox Valley. Both parents or legal guardians must typically be present at the acceptance facility, and we guide you through the entire process." },
  ],
  photoLocations: [
    { name: "Walgreens — Aurora Broadway", address: "1275 N Lake St, Aurora, IL 60506", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/" },
    { name: "UPS Store — Aurora", address: "3930 Tollgate Blvd, Aurora, IL 60504", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM", website: "https://www.theupsstore.com/" },
    { name: "CVS — Aurora Ogden", address: "2000 W Galena Blvd, Aurora, IL 60506", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "FedEx Office — Aurora", address: "4470 N Route 47, Aurora, IL 60542", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.fedex.com/" },
  ],
  dmvLocations: [
    { name: "Illinois SOS — Aurora", address: "3390 S Aurora Ave, Aurora, IL 60504", hours: "Mon–Fri: 8:00AM–5:00PM", note: "Illinois Secretary of State for driver's licenses, REAL ID, and vehicle registration. Online reservations strongly recommended.", featured: true },
    { name: "Illinois SOS — Geneva", address: "1725 S State St, Geneva, IL 60134", hours: "Mon–Fri: 8:00AM–5:00PM", note: "Serves Geneva, St. Charles, and northern Aurora area. Full REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "ORD",
      name: "Chicago O'Hare International Airport",
      distance: "Approximately 45 minutes east via I-88",
      address: "10000 W O'Hare Ave, Chicago, IL 60666",
      note: "Primary international airport for Aurora and the Fox Valley. One of the world's busiest airports with direct flights to Europe, Asia, and the Americas. United and American Airlines hub.",
      flightUrl: "https://www.flychicago.com/ohare/",
      flightLabel: "ORD Flight Info",
      featured: true,
    },
    {
      code: "MDW",
      name: "Chicago Midway International Airport",
      distance: "Approximately 55 minutes east via I-88 and I-55",
      address: "5700 S Cicero Ave, Chicago, IL 60638",
      note: "Southwest Airlines hub with domestic connections. Good for travelers flying Southwest to connect to international destinations.",
      flightUrl: "https://www.flychicago.com/midway/",
      flightLabel: "MDW Flight Info",
      featured: false,
    },
    {
      code: "DPA",
      name: "DuPage Airport",
      distance: "Approximately 30 minutes northeast via IL-59",
      address: "2700 International Dr, West Chicago, IL 60185",
      note: "Regional general aviation airport. Not a commercial hub, but used for private and charter flights.",
      flightUrl: "https://www.dupageairport.com/",
      flightLabel: "DPA Info",
      featured: false,
    },
  ],
};